import {
  Duration,
  Instant,
  LocalDate,
  LocalTime,
  ZonedDateTime,
} from "@js-joda/core";
import { stringJsonFormat } from "@redotech/json/format";
import { bijectionCompose } from "@redotech/util/bijection";

export const durationJsonFormat = bijectionCompose(stringJsonFormat, {
  read: Duration.parse,
  write: String,
});

export const instantJsonFormat = bijectionCompose(stringJsonFormat, {
  read: Instant.parse,
  write: String,
});

export const localDateJsonFormat = bijectionCompose(stringJsonFormat, {
  read: LocalDate.parse,
  write: String,
});

export const localTimeJsonFormat = bijectionCompose(stringJsonFormat, {
  read: LocalTime.parse,
  write: String,
});

export const zonedDateTimeJsonFormat = bijectionCompose(stringJsonFormat, {
  read: ZonedDateTime.parse,
  write: String,
});
